import { ApiResponse } from '@/types/api'

export class DataProcessing {
    public static processCountriesData = (
        countriesData: ApiResponse<{ id: number; name: string }[]>
    ) => {
        return Array.isArray(countriesData) && countriesData.length > 0
            ? countriesData
                  .filter((item) => item.value && item.label)
                  .map((item) => ({
                      value: item.value,
                      label: item.label
                  }))
            : []
    }

    public static processNationalitiesListData = (
        nationalitiesListData: ApiResponse<{ id: number; name: string }[]>
    ) => {
        return Array.isArray(nationalitiesListData) &&
            nationalitiesListData.length > 0
            ? nationalitiesListData
                  .filter((item) => item.value && item.label)
                  .map((item) => ({
                      value: item.value,
                      label: item.label
                  }))
            : []
    }

    public static processCitiesData = (
        citiesData: ApiResponse<{ id: number; name: string }[]>
    ) => {
        return Array.isArray(citiesData) && citiesData.length > 0
            ? citiesData
                  .filter((item) => item.CityCode && item.label)
                  .map((item) => ({
                      value: item.CityCode,
                      label: item.label
                  }))
            : []
    }

    public static processDepartmentsData = (departmentsData: any[]) => {
        if (!Array.isArray(departmentsData)) {
            return []
        }

        return departmentsData
            .filter((item) => item !== null) // Filtrar elementos nulos
            .map((item) => ({
                value: item.Region || item.region || item.value || '',
                label: item.Bezei || item.name || item.label || ''
            }))
            .filter((item) => item.value && item.label) // Filtrar elementos sin valor o etiqueta
    }

    public static processLocalityData = (localityData: any[]) => {
        return Array.isArray(localityData) && localityData.length > 0
            ? localityData
                  .filter((item) => item.value && item.label)
                  .map((item) => ({
                      value: `${item.value}-${item.label}`,
                      label: item.label
                  }))
            : []
    }

    public static processTimeResidenceData = (timeResidenceData: any[]) => {
        return Array.isArray(timeResidenceData) && timeResidenceData.length > 0
            ? timeResidenceData
                  .filter((item) => item.Posicion !== '000' && item.Descripcion)
                  .map((item) => ({
                      value: item.Posicion,
                      label: item.Descripcion
                  }))
            : []
    }
}
